import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface MinimalFooterProps {
  variant?: 'desktop' | 'mobile';
}

const MinimalFooter = ({ variant = 'desktop' }: MinimalFooterProps) => {
  const { t } = useTranslation();
  const isDesktop = variant === 'desktop';

  return (
    <footer
      className={`w-full overflow-hidden bg-surface-inverse ${
        isDesktop ? 'px-20 py-5' : 'px-5 py-4'
      }`}
    >
      <div
        className={`mx-auto flex items-center justify-between ${
          isDesktop ? 'max-w-[1440px]' : ''
        }`}
      >
        <p
          className={`font-body text-white/60 ${isDesktop ? 'text-sm' : 'text-xs'}`}
        >
          {t('home.footer.copyright')}
        </p>
        <div className={`flex ${isDesktop ? 'gap-5' : 'gap-4'}`}>
          <button
            type="button"
            className="text-white/50 transition-colors hover:text-white/80"
            aria-label="Facebook"
          >
            <Facebook size={isDesktop ? 18 : 16} />
          </button>
          <button
            type="button"
            className="text-white/50 transition-colors hover:text-white/80"
            aria-label="Twitter"
          >
            <Twitter size={isDesktop ? 18 : 16} />
          </button>
          <button
            type="button"
            className="text-white/50 transition-colors hover:text-white/80"
            aria-label="Instagram"
          >
            <Instagram size={isDesktop ? 18 : 16} />
          </button>
          <button
            type="button"
            className="text-white/50 transition-colors hover:text-white/80"
            aria-label="LinkedIn"
          >
            <Linkedin size={isDesktop ? 18 : 16} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default MinimalFooter;
